// Shared adjustment metadata (kept out of the page files so both can import it without
// tripping React fast-refresh's component-only-export rule).
export const ADJUSTMENT_TYPES: { value: string; label: string; help: string; quarantine?: boolean }[] = [
  { value: "DAMAGE", label: "Damage", help: "Recoverable - moves the quantity into that location's quarantine." },
  { value: "WASTAGE", label: "Wastage", help: "Unrecoverable - posted to the loss sink." },
  { value: "LOSS", label: "Loss", help: "Unrecoverable - posted to the loss sink." },
  { value: "CORRECTION", label: "Physical-count correction", help: "Signed: positive for stock found, negative for stock missing." },
  {
    value: "QUARANTINE_RESTOCK",
    label: "Quarantine: restock",
    help: "Repaired or re-inspected - moves the quantity out of quarantine and back into its parent store as usable stock.",
    quarantine: true,
  },
  {
    value: "QUARANTINE_WRITE_OFF",
    label: "Quarantine: write off",
    help: "Scrapped - moves the quantity out of quarantine to the loss sink. It leaves the books for good.",
    quarantine: true,
  },
];

export function isQuarantineAdjustment(type?: string): boolean {
  return !!ADJUSTMENT_TYPES.find((t) => t.value === type)?.quarantine;
}
